import { CheerzApiCreditCard } from "@Types/api/creditCard";
import CreditCard from "@Types/creditCard";

export const convertCreditCardFromApiToContent = (
  jsonContent: CheerzApiCreditCard | null
): CreditCard => {
  return {
    cardType: jsonContent ? jsonContent.card_type : undefined,
    identifier: jsonContent ? jsonContent.identifier : undefined,
    month: jsonContent ? jsonContent.month : undefined,
    year: jsonContent ? jsonContent.year : undefined,
  };
};
